

















































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
    AllowedPostType,
    Settings,
    TransitionTypes,
    InteractionTypes,
    AllowedPostSettings
} from "@/services/channels/types";
import {
    hasSettingsComponent,
    postTypes as PostTypes,
    getPostTypeTranslationKey,
    settingsComponents,
    settingsSufix
} from "@/components/posts/PostTypeRegister";
import i18n from "@/i18n";
import { Style, ChannelStyle } from "@/services/styles/types";
import { settingsValidators } from "@/components/channels/validators";
import validate from "@/directives/validate";
import { postTypesFields } from "@/components/channels/fields/postTypesFields";
import vSelect from "vue-select";
import order from "@/components/posts/PostTypeOrder";
import { getApplicationSettings } from "@/services/applicationSettings/applicationSettingsService";
import { ApplicationSettings } from "@/services/applicationSettings/types";

@Component({
    methods: { getPostTypeTranslationKey },
    components: {
        vSelect,
        ...settingsComponents
    },
    directives: {
        validate
    },
    filters: {
        settings(value: string) {
            return value.concat(settingsSufix);
        }
    }
})
export default class ChannelSettings extends Vue {
    @Prop() settings!: Settings;
    @Prop() styles!: Style[];
    @Prop() allowedPostTypes!: AllowedPostSettings[];
    @Prop() alreadyUsedPostTypes!: string[];
    @Prop() allowedPostTypesState!: boolean;
    @Prop() menuStyles!: ChannelStyle[];
    @Prop() durationStyles!: ChannelStyle[];
    @Prop() counterStyles!: ChannelStyle[];
    @Prop() channelId!: string;

    // local state
    localSettings = {} as Settings;
    intTypes = InteractionTypes;

    localAllowedPostTypes = JSON.parse(JSON.stringify(this.allowedPostTypes)) as AllowedPostSettings[];
    postTypeListing = [] as AllowedPostType[];

    transitionTypes: any = Object.keys(TransitionTypes).map(key => ({
        name: i18n.t(`channels.${key}`),
        id: key
    }));

    interactionTypes: any = Object.keys(InteractionTypes).filter(x => x !== InteractionTypes.menuFlat).map(key => ({
        name: i18n.t(`channels.${key}`),
        id: key
    }));

    fields = postTypesFields;
    validators = settingsValidators;
    i18n = i18n;

    currentErrorType = "";
    errorTypeTimer = 0;
    defaultTransitionTime = 300;
    defaultShowTime = 15;

    // lifecycle hooks
    mounted() {
        this.localSettings = this.settings;
        // temporary solution
        getApplicationSettings({ keys: ["WayfinderInstanceId"] }).then((response: ApplicationSettings) => {
            if (response.wayfinderInstanceId <= 0) {
                delete PostTypes.Wayfinder;
            }
        });
        this.localSettings.defaultShowTime = this.settings.defaultShowTime ? this.settings.defaultShowTime : this.defaultShowTime;
        this.processPostTypeListing();
    }

    // Watchers
    @Watch("settings")
    onPropertyChanged() {
        this.localSettings = this.settings;
    }

    @Watch("allowedPostTypes")
    onAllowedPostTypesPropertyChanged() {
        this.localAllowedPostTypes = JSON.parse(JSON.stringify(this.allowedPostTypes)) as AllowedPostSettings[];
        this.processPostTypeListing();
    }

    processPostTypeListing() {
        const allPostTypes = JSON.parse(JSON.stringify(PostTypes));
        this.postTypeListing = Object.keys(allPostTypes).map(key => {
            const isSelected = (this.localAllowedPostTypes && this.localAllowedPostTypes.some(item => item.postType === key));
            return {
                key: key,
                selected: isSelected,
                isNew: !isSelected
            } as AllowedPostType;
        }).sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
    }

    extractPostTypeModel(postType: string) : AllowedPostSettings {
        const model = this.localAllowedPostTypes.find(x => x.postType === postType);
        return model || { postType: postType } as AllowedPostSettings;
    }

    // computed
    get editMode() {
        return !!this.channelId;
    }

    get selectedChannelItemTypes() {
        return this.postTypeListing.filter(x => x.selected && hasSettingsComponent(x.key));
    }

    get renderTransitionTime(): boolean {
        const showTransitionTime = this.localSettings.transitionType !== undefined && this.localSettings.transitionType !== "none";
        if (showTransitionTime) {
            this.localSettings.transitionTime = this.settings.transitionTime !== undefined && this.settings.transitionTime > 0 ? this.settings.transitionTime : this.defaultTransitionTime;
        }
        return showTransitionTime;
    }

    // methods

    togglePostType(postType: AllowedPostType) {
        const disabled = (this.alreadyUsedPostTypes.filter(x => x.toLowerCase() === postType.key.toLowerCase()).length > 0);
        if (disabled) {
            this.notifyIfDisabled(postType.key);
        } else {
            postType.selected = !postType.selected;
            var postTypeSetting = this.extractPostTypeModel(postType.key);
            if (postType.selected) {
                this.localAllowedPostTypes.push(postTypeSetting);
            } else {
                this.localAllowedPostTypes = this.localAllowedPostTypes.filter(x => x.postType !== postType.key);
            }
        }
    }

    filteredStyles(postType: string): Style[] {
        const sc = this.styles.filter(option => option.postType === postType);
        if (sc.length > 0) sc.sort((a, b) => a.name.localeCompare(b.name, "en"));
        sc.unshift({
            id: "",
            name: i18n.t(`channels.noStyle`) as string,
            postType: "",
            css: ""
        } as Style);
        return sc;
    }

    retrieveData() {
        this.selectedChannelItemTypes.forEach((postType) => {
            const refName = `component-${postType.key}`;
            const refs = this.$refs[refName];
            const components = Array.isArray(refs) ? refs : [refs];
            components.forEach((componentInstance: any) => {
                if (componentInstance && componentInstance.$el) {
                    if (typeof componentInstance.emitData === "function") {
                        componentInstance.emitData();
                    }
                }
            });
        });
    }

    allowedPostSettingsUpdated(allowedPostSettingsObj: AllowedPostSettings) {
        const index = this.localAllowedPostTypes.findIndex(obj => obj.postType === allowedPostSettingsObj.postType);
        if (index !== -1) {
            this.localAllowedPostTypes[index] = allowedPostSettingsObj;
        }
    }

    updateAllowedTypes() {
        this.$nextTick(() => {
            this.$emit(
                "allowedItemTypesUpdated",
                this.postTypeListing
                    .filter(option => option.selected)
                    .map(x => x.key)
            );
        });
    }

    emitData() {
        if (this.localSettings.transitionType === TransitionTypes.none) {
            this.validators.transitionTime.state = true;
        }

        this.retrieveData();

        this.$nextTick(() => {
            // project selected post type data
            const selectedPostTypes = new Set(this.postTypeListing.filter(item => item.selected).map(item => item.key));
            var allowedPostTypes = this.localAllowedPostTypes.filter(item => selectedPostTypes.has(item.postType));

            // deep copy to avoid binding
            this.$emit(
                "settingsUpdated",
                JSON.stringify({
                    settings: this.localSettings,
                    items: JSON.stringify(allowedPostTypes)
                })
            );
        });
    }

    notifyIfDisabled(id: string) {
        this.currentErrorType = id;
        clearTimeout(this.errorTypeTimer);
        this.errorTypeTimer = setTimeout(() => {
            this.currentErrorType = "";
        }, 10000);
    }

    channelStylesUpdateRoute(styleId: string) {
        if (!styleId) return "#";
        return {
            name: "updateChannelStyles",
            params: { styleId: styleId }
        };
    }
}
